module.exports = __webpack_public_path__ + "img/user-group2_en.ea62a2b2.png";